import React, {Component} from "react";
import {Col, Media, Row} from "reactstrap";
import {Subscribe} from "unstated";
import ConnectionStatus from "../../state/ConnectionStatus";
import FilterState from "../../state/FilterState";
import BuildupTemplateSelect from "../buildup/BuildupTemplateSelect";
import OfflineTemplateSelect from "../buildup/OfflineTemplateSelect";
import PrimaryFilterGroup from "../filter/PrimaryFilterGroup";

class Sidebar extends Component {
  public render() {
    return (
      <Subscribe to={[FilterState, ConnectionStatus]}>
        {(filterState: any, connectionStatus: any) => {
          const {state: {filters, imageLocation}} = filterState;
          const {state: {isOnline}} = connectionStatus;
          const handleFilterValue = (filterId: string, value: string) => filterState.handleFilterValue(filterId, value);
          const primaryFilters = filters.filter((f: any) => f.isPrimary);
          console.log("filters", filters);

          return (
            <React.Fragment>
              {imageLocation.trim() !== "" ? (
                <Row>
                  <Col className="d-flex justify-content-center pt-2">
                    <Media
                      object={true}
                      src={imageLocation}
                      style={{
                        display: "block",
                        height: "17rem",
                        width: "17rem"
                      }}
                    />
                  </Col>
                </Row>
              ) : null}
              {isOnline ? <BuildupTemplateSelect/> : <OfflineTemplateSelect/>}
              <PrimaryFilterGroup
                primaryFilters={primaryFilters}
                handleValueChange={handleFilterValue}
              />
            </React.Fragment>
          );
        }}
      </Subscribe>
    );
  }
}

export default Sidebar;
